import React, { useState } from 'react';
import { Button, Divider } from 'antd';

import { useAuth } from 'hooks';
import { COMPLIANCE_KB_NETWORKS } from 'lib/constants';

import complianceIcon from 'assets/images/compliance-bwg.png';

import ComplianceChatModal from './ComplianceChatModal';
import * as S from './ComplianceStyles';

/**
 * Botão "Compliance BWG" da sidebar da Home. Abre o modal com o iframe do
 * chatbot de Compliance.
 *
 * O rótulo é nome de produto, por isso não passa pelo i18n.
 */
const ComplianceButton: React.VFC = () => {
  const { networkId } = useAuth();
  const [open, setOpen] = useState(false);

  /**
   * Solta o foco do gatilho antes de abrir. O antd marca a árvore de fora do
   * modal como aria-hidden, e um elemento focado dentro dessa árvore faz o
   * navegador recusar o atributo — o foco ficaria escondido de leitor de tela.
   */
  const openChat = (event: React.MouseEvent<HTMLElement>) => {
    event.currentTarget.blur();
    setOpen(true);
  };

  if (!COMPLIANCE_KB_NETWORKS.includes(networkId)) return null;

  return (
    <>
      <S.SidebarButton>
        <Divider />
        <Button size="large" onClick={openChat}>
          <img src={complianceIcon} alt="" />
          <span>Compliance BWG</span>
        </Button>
      </S.SidebarButton>

      <ComplianceChatModal visible={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default ComplianceButton;
